import PropTypes from 'prop-types';
import React from 'react';

import { MAIN_CONTENT_ID } from './constants';

function LayoutDefault({ children, isMainLandmark = true }) {
  // == Solo el shell de página emite el landmark main; anidado renderiza un div para no
  // == duplicarlo ni duplicar el id del skip link.
  const ContentTag = isMainLandmark ? 'main' : 'div';
  const mainLandmarkProps = isMainLandmark ? { id: MAIN_CONTENT_ID, tabIndex: -1 } : {};

  return (
    <ContentTag className="layout-default" {...mainLandmarkProps}>
      {children}
    </ContentTag>
  );
}

LayoutDefault.propTypes = {
  children: PropTypes.node,
  isMainLandmark: PropTypes.bool,
};

export default LayoutDefault;
